module.exports = __webpack_public_path__ + "f4059bad2499cfe6e33b83eb1c674035.svg";